import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Drag-reorders the wide-format metric rows. Its own controller rather than a method on
// edit_card_query so Stimulus re-connects it automatically each time a preview run replaces the
// settings panel -- re-initialising by hand raced Turbo's async DOM swap and left Sortable bound to
// detached rows after the first drag.
export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-metric-handle]",
      ghostClass: "opacity-40",
      // The rows post in DOM order, so a drop IS the new metric order; re-run to redraw the chart.
      onEnd: () => this.dispatch("reordered"),
    });
  }

  disconnect() {
    this.sortable?.destroy();
  }
}
